import Dialog from "@/components/common/Dialog";
import PaymentPlans from "@/components/PaymentPlans";
import  { createContext, useContext, useState, ReactNode } from "react";

// Define the context type
type PlanValidationContextType = {
  openDialog: () => void;
  closeDialog: () => void;
};

// Create the context with the correct type
const PlanValidationContext = createContext<PlanValidationContextType | undefined>(undefined);

// Create the provider component that manages the dialog and validation logic
export const PlanValidationProvider = ({ children }: { children: ReactNode }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Function to open the dialog
  const openDialog = () => {
    setIsDialogOpen(true);
  };

  // Function to close the dialog
  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <PlanValidationContext.Provider value={{ openDialog, closeDialog }}>
      {children}
      {/* Dialog Component */}
      <Dialog
        isOpen={isDialogOpen}
        onClose={closeDialog}
        modalClass="rounded-lg px-5"
      >
        {/* PaymentPlans Component */}
        <PaymentPlans onClose={closeDialog} />
      </Dialog>
    </PlanValidationContext.Provider>
  );
};

// Custom hook to use the PlanValidationContext
export const usePlanValidationContext = () => {
  const context = useContext(PlanValidationContext);
  if (!context) {
    throw new Error("usePlanValidationContext must be used within a PlanValidationProvider");
  }
  return context;
};
